xplenty.service('offline', [
  function () {
    Offline.options = {
      // Should we check the connection status immediatly on page load.
      checkOnLoad: false,
      // Should we monitor AJAX requests to help decide if we have a connection.
      interceptRequests: true,
      // Should we store and attempt to remake requests which fail while the connection is down.
      requests: false,
      // Should we show a snake game while the connection is down to keep the user entertained?
      // It's not included in the normal build, you should bring in js/snake.js in addition to
      // offline.min.js.
      game: false,
      //
      checks: { xhr: { url: `${process.env.API_URL}/favicon.ico` } },
    };
  },
]);
